import { memo, useCallback } from 'react'
import SearchableDropdown from 'components/SearchableDropdown'
import { ITtsSpeaker } from 'types/text-to-speech'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import TtsSpeakerItem from './Item'
import * as Styled from './styled'
import { ITtsSpeakerDropdownProps } from './types'

const SpeakerDropdown: React.FC<ITtsSpeakerDropdownProps> = (
  props: ITtsSpeakerDropdownProps
) => {
  const {
    speakersData,
    selectedSpeakerId,
    onSpeakerClick,
    isDataLoading,
    scrollableParentRef,
    className,
    childClassName
  } = props

  const onClick = useCallback(
    (id: string | number) => {
      onSpeakerClick(id as number)
    },
    [onSpeakerClick]
  )

  return (
    <Styled.SpeakerDropdownWrapper className={className}>
      <SearchableDropdown
        className="speaker-dropdown"
        items={speakersData}
        selectedItemId={selectedSpeakerId}
        searchKeys={['displayName']}
        title={translate(T.VOICE)}
        onItemClick={onClick}
        isLoading={isDataLoading}
        ChildComponent={props => (
          <TtsSpeakerItem
            {...props}
            item={props.item as ITtsSpeaker | null}
            type="speaker"
            className={childClassName}
          />
        )}
        scrollableParentRef={scrollableParentRef}
      />
    </Styled.SpeakerDropdownWrapper>
  )
}

export default memo(SpeakerDropdown)
